<div class="l-row header">
  <div class="title-banner bg-page-title">
    <img src="/global/images/logos/eia_logo_only_print.png" class="print" alt="">
    <h1>Natural Gas Storage Dashboard</h1>
    <div class="pub-title">
      <span *ngIf="dashboardLastUpdated !== null">Dashboard last updated: {{dashboardLastUpdated | date : "MMMM d, y"}}</span>
      <span *ngIf="dashboardNextUpdate !== null">Next update: {{dashboardNextUpdate | date : "MMMM d, y"}}</span>
      <span *ngIf="commentaryLastUpdated !== null" class="do-not-print">Commentary last updated: {{commentaryLastUpdated | date : "MMMM d, y"}}</span>
      <span class="do-not-print"><app-pdf-selector></app-pdf-selector></span>
    </div>
  </div>
</div>
<div class="dashboard-container l-full-width-page">
  
  <div class="l-row">
    <div class="l-full-width-col">
      <div class="page-nav">
        <div class="left">
          <ul class="left-nav">
            <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"><a routerLink="" queryParamsHandling="preserve">National</a></li>
            <li routerLinkActive="active"><a routerLink="regional" queryParamsHandling="preserve">Regional</a></li>
			      <li routerLinkActive="active"><a routerLink="commentary" queryParamsHandling="preserve">Commentary</a></li>

          </ul>
        </div>
        <div class="right">
            <span class="right-nav">
                <a href="javascript:void(0)" (click)="openLatestPDF()" ngShow="latestReport !== null" style="margin-top:2px;"><span class="ico pdf"></span> Print dashboards</a>
                <a id="startTourBtn" href="#takeATour" style="margin-top:-4px;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn2" href="#takeATour2" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn3" href="#takeATour3" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn4" href="#takeATour4" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn5" href="#takeATour5" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn6" href="#takeATour6" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn7" href="#takeATour7" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn8" href="#takeATour8" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn9" href="#takeATour9" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn10" href="#takeATour10" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn11" href="#takeATour11" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn12" href="#takeATour12" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn13" href="#takeATour13" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn14" href="#takeATour14" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
                <a id="startTourBtn15" href="#takeATour15" style="margin-top:-4px; display:none;" class="tourBox" rel="gallery1"><span class="ico tour"></span> Take a tour</a>
            </span>
        </div>
      </div>
    </div>
  </div>
  <hr>
  <router-outlet></router-outlet>
  <div style="display:none">
    <div id="takeATour">
      <div>
        <div class="tourTitle" >Weekly Natural Gas</div>
        <div class="tourBodyCols">
          <div class="tourBodyTop" ><img src="assets/images/takeATour/TitleInformation.png" alt="Weekly Natural Gas"/></div>
          <div class="tourBodyBottom">
            
              <p>EIA’s Weekly Natural Gas Dashboard title page provides summary information including:</p>
            <ul>
              <li>The date of the latest report</li>
              <li>The date of the most recent blog or commentary</li>
              <li>Navigation to archived reports</li>
              <li>Tabs for report features</li>
              <li>The most recent estimate of Lower 48 working gas stocks</li>
              <li>An arrow indicating whether the weekly net change was a net injection (up arrow) or net withdrawal (down arrow) for the week ending on the specified date.</li>
            </ul>
          </div>
      </div>
    </div>
  </div>


    <div id="takeATour2">
      <div>
        <div class="tourTitle" >Commentary Section</div>
        <div class="tourBodyCols">
          <div class="tourBodyTop" ><img src="assets/images/takeATour/Commentary.png" alt="Commentary Section"/></div>
          <div class="tourBodyBottom">
            
            <p>Occasionally, EIA will include short posts that discuss changes in natural gas storage activity or related natural gas market conditions.</p></div>
        </div>
      </div>
    </div>

    <div id="takeATour3">
      <div>
        <div class="tourTitle" >Lower 48 Working Gas Storage Summary</div>
        <div class="tourBody">
          <div class="tourBodyLeft" ><img src="assets/images/takeATour/NatGasStorageSummary.png" alt="Lower 48 Working Gas Storage Summary"/></div>
          <div class="tourBodyRight">
            
            <p>This chart shows current working gas stocks and estimated storage capacity utilization by storage region (shown on the map) and for the Lower 48 states. For stocks, it also provides data on the 52 week min/max levels and the five-year min/max levels by region and for the Lower 48. Users can download the image or data for this and other graphics in the dashboard.</p>
          </div>
        </div>
      </div>
    </div>


      <div id="takeATour4">
        <div>
          <div class="tourTitle" >Weather Map</div>
          <div class="tourBody">
            <div class="tourBodyLeft" ><img src="assets/images/takeATour/NatGasWeatherMap.png" alt="Weather Map"/></div>
            <div class="tourBodyRight">
              <p>The heat map displays weekly and daily average temperatures based on National Oceanic and Atmospheric Administration (NOAA) population-weighted heating degree and cooling degree data, calculated by NOAA state climate divisions with storage region overlays. This feature has three options:</p>
              <ul>
                <li>A map of average temperatures for the current storage reporting week compared with the thirty-year (e.g., 1981-2010) normal for the same time period</li>
                <li>A map showing how average temperatures varied for the current storage reporting week compared with the prior week</li>
                <li>An animation showing the daily absolute temperatures during the past two weeks</li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <div id="takeATour5">
        <div>
          <div class="tourTitle" >Lower 48 Underground Working Gas Stocks</div>
          <div class="tourBody">
            <div class="tourBodyLeft" ><img src="assets/images/takeATour/NatGasLower48UGWorkingGasStocks.png" alt="Lower 48 Underground Working Gas Stocks"/></div>
            <div class="tourBodyRight">
              <p>This chart shows EIA’s latest Lower 48 weekly estimates of working gas in underground natural gas storage facilities. The chart shows storage inventories for different time periods:</p>
              <ul>
                <li>Current year (blue line)</li>
                <li>Prior year (green line)</li>
                <li>Most recent five-year average (black line)</li>
                <li>Most recent five-year minimum/maximum range (gray band).</li>
              </ul>
              
            </div>
          </div>
        </div>
      </div>



      <div id="takeATour6">
        <div>
          <div class="tourTitle" >Lower 48 Daily Temperatures</div>
          <div class="tourBody">
            <div class="tourBodyLeft" ><img src="assets/images/takeATour/NatGasLower48DailyTemperatures.png" alt="Lower 48 Daily Temperatures"/></div>
            <div class="tourBodyRight">
              
              <p>This chart shows recent and near-future forecasts of daily average temperatures for the United States compared with the normal and record high/low average for each day. </p>
              <p>For the winter, temperatures are a good measure of likely furnace load for space heating needs and for the summer, warmer-than-normal temperatures can affect working gas storage activity. </p>
              <p>The daily data are population-weighted. The dashed vertical line indicates the report week versus the upcoming storage week (current week).  </p>
            </div>
          </div>
        </div>
      </div>


      <div id="takeATour7">
        <div>
          <div class="tourTitle" >Net Inventory Change</div>
          <div class="tourBody">
            <div class="tourBodyLeft" ><img src="assets/images/takeATour/NatGasNetInventoryChange.png" alt="Net Inventory Change"/></div>
            <div class="tourBodyRight">
              
              <p>This chart highlights week-over-week changes in storage activity. Weekly net change in storage inventory is shown several ways:</p>
              <ul>
                <li>Storage inventory from the prior week (blue dot)</li>
                <li>Average storage inventory activity for this week over the past five years (the dark gray diamond) </li>
                <li>Minimum/maximum range for this storage report week over the past five-years (the gray area)   </li>
              </ul>
            </div>
          </div>
        </div>
      </div>


      <div id="takeATour8">
        <div>
          <div class="tourTitle" >Key Sources of Natural Gas Consumption</div>
          <div class="tourBodyCols">
            <div class="tourBodyTop" >
              <img src="assets/images/takeATour/NatGasNaturalGasConsumption.png" alt="Key Sources of Natural Gas Consumption"/>
            </div>
            <div class="tourBodyBottom">
              
              <p>These charts show daily changes in natural gas consumption for the 14-day period of the current storage report week and the upcoming storage report week. </p>
              <p>Changes in natural gas consumption in the residential/commercial and electricity generation sectors can affect seasonal storage balances. Both charts show trends for the current year, the prior year, and the most recent five-year minimum/maximum range. </p>
              <p>These charts are based on third-party estimates. The dashed vertical line indicates the report week versus the upcoming storage week (current week).  </p>
            </div>
          </div>
        </div>
      </div>


      <div id="takeATour9">
        <div>
          <div class="tourTitle">Working Gas Stocks and Futures Prices</div>
          <div class="tourBody">
            <div class="tourBodyLeft">
              <img src="assets/images/takeATour/NatGasStocksAndFutures.png" alt="Working Gas Stocks and Futures Prices"/>
            </div>
            <div class="tourBodyRight">
              
              <p>The scatterplot shows the relationship between EIA’s reported Lower 48 natural gas inventories each week and the near-month NYMEX natural gas futures settlement price at Henry Hub.</p>
              <ul>
                <li>The x-axis indicates the current working gas level compared with the most recent five-year average.</li>
                <li>Values to the left of the zero market on the x-axis indicate stocks are lower than the current five-year average.</li>
                <li>Values to the right of the zero marker on the x-axis indicate stocks are higher than the current five-year average.</li>
                <li>The y-axis shows the near-month futures price of gas.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>



      <div id="takeATour10">
        <div>
          <div class="tourTitle">Nuclear Plant Availability</div>
          <div class="tourBody">
            <div class="tourBodyLeft">
              <img  src="assets/images/takeATour/NatGasNuclear.png" alt="Nuclear Plant Availability"/>
            </div>
            <div class="tourBodyRight">
              
              <p>This chart shows daily nuclear generating capacity outages (planned and unplanned) based on information from the
                U.S. Nuclear Regulatory Commission.</p>
              <ul>
                <li> Outages at nuclear generating plants can affect the fuels needed to meet regional power loads.</li>
                <li> Natural gas-fired plants may be dispatched when nuclear outages occur, which can affect natural gas storage requirements.</li>
                <li> Data cover the current year, prior year, and most recent five-year minimum/maximum range. </li>
              </ul>
            </div>
          </div>
        </div>
      </div>



      <div id="takeATour11">
        <div>
          <div class="tourTitle">Regional Natural Gas Stocks</div>
          <div class="tourBodyCols">
            <div class="tourBodyTop">
              <img src="assets/images/takeATour/NatGasRegionalNaturalGasStocks.png" alt="Regional Natural Gas Stocks"/>
            </div>
            <div class="tourBodyBottom bullets">
              <p>For each natural gas storage reporting region, the dashboard shows a chart of the weekly underground natural gas
                inventories for the</p>
              <ul>
                <li>Current Year and Prior Year</li>
                <li>The Average and Minimum/Maximum range for the most current five-year period.</li>
              </ul>
              <p>EIA provides charts for these estimates for each of the five storage regions, including breakouts for Salt and
                Nonsalt facilities in the South Central region.</p>

            </div>
          </div>
        </div>
      </div>



      <div id="takeATour12">
        <div>
          <div class="tourTitle">Net Inventory Change by Region</div>
          <div class="tourBody">
            <div class="tourBodyLeft">
              <img src="assets/images/takeATour/NatGasNetInventoryChangeRegion.png" alt="Net Inventory Change by Region"/>
            </div>
            <div class="tourBodyRight">
              
              <p>EIA provides charts for the weekly net change in natural gas stocks by storage region, which includes a breakout
                of the change in stocks for the salt and nonsalt facilities within the South Central region.</p>
              <p>Net change is the absolute change in storage working gas levels measured week over week. The chart reports three
                kinds of regional net changes:</p>
              <ul>
                <li>Current-year values (blue dot)</li>
                <li>The five-year average (dark gray diamond)</li>
                <li>The five-year range for a given reporting week (gray area)</li>
              </ul>
              <p>Ranges are usually wider in the winter and narrower in the summer.</p>

            </div>
          </div>
        </div>
      </div>



      <div id="takeATour13">
        <div>
          <div class="tourTitle">Net Exports of Natural Gas</div>
          <div class="tourBody">
            <div class="tourBodyLeft">
              <img src="assets/images/takeATour/NatGasNetExports.png" alt="Net Exports of Natural Gas"/>
            </div>
            <div class="tourBodyRight">
              
              <p>This chart summarizes the net natural gas export position of the Lower 48 states each day. It shows the sum of
                all natural gas exports to Canada and Mexico by pipeline and natural gas feedstock delivered to U.S. liquefied
                natural gas (LNG) export terminals (treated as a proxy for LNG exports) minus any pipeline imports from Canada
                and Mexico and LNG imports.</p>
              <p>Send-out to U.S. LNG regasification terminals is a proxy for daily LNG imports. The net of total exports and imports
                indicates whether the United States is a net exporter or importer of natural gas. EIA provides this data for the current
                two-week period, for the current year, the previous year, and the current five-year minimum/maximum range.</p>
              <p>The disposition of natural gas exports can affect natural gas storage balances. The dashed vertical line indicates
                the report week versus the upcoming storage week (current week).</p>
            </div>
          </div>
        </div>
      </div>



      <div id="takeATour14">
        <div>
          <div class="tourTitle">Heat Table</div>
          <div class="tourBody">
            <div class="tourBodyLeft">
              <img src="assets/images/takeATour/NatGasHeatTable.png" alt="Heat Table"/>
            </div>
            <div class="tourBodyRight">
              
              <p>The heat table shows actual and forecasted daily temperatures and how they varied from thirty-year (e.g., 1981&ndash;2010)
                normal average temperatures based on NOAA data.</p>
              <p>Data are aggregated and averaged based on storage regions in the
                <em>Weekly Natural Gas Storage Report</em>.</p>
              <p>Temperatures that have been warmer than normal appear as a shade of brown, and temperatures that have been cooler
                than normal appear as a shade of blue.</p>
            </div>
          </div>
        </div>
      </div>



      <div id="takeATour15">
        <div>
          <div class="tourTitle">Natural Gas Futures Prices</div>
          <div class="tourBody">
            <div class="tourBodyLeft">
              <img src="assets/images/takeATour/NatGasFutures.png" alt="Natural Gas Futures Prices"/>
            </div>
            <div class="tourBodyRight">
              
              <p>This chart presents NYMEX natural gas futures settlement prices for the next 12 months (also referred to as a strip)
                following the current WNGSR release.</p>
              <p>The natural gas futures price curves partly reflect changes in weekly natural gas storage inventories as a result
                of shifts in natural gas supply and demand.</p>
              <p>Three lines show the 12-month strip of settlement prices:</p>
              <ul>
                <li>Formed on the day before the current WNGSR release</li>
                <li>From the previous week’s WNGSR release day</li>
                <li>Established a year ago on the WNGSR release day</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app.component.html